export const environment = {
	production: true,

	api: {
		host: 'https://appapi.pointhealthtech.com',
	},

	billNegotiation: {
		baZingPlanCode: 'PL-C46DA1C9',
		defaultPlanCode: 'PL-FAF77956',
	},

	stripe: {
		publishableKey: 'pk_live_51HZimCKtqDXmWNvwvC5xAjY3URDMtpStgsfcDbjLiQbpbANXmt16KBLfqnsxKiF0VIpXdOYGk74vg5z3jrWfrjXK006cdRp6lP',
	},
};
